<template>
  <div class="invest-intro">
    <div class="invest-intro-container">
      <div class="invest-intro-start">
        <h1>
          <span>5,000 Return</span> <br />
          On Investment Opportunity?
        </h1>
        <p>
          One of the <strong>WORLD's LARGEST</strong> automotive
          <strong>USED CARS</strong> listing
        </p>
        <p>
          <strong>OOYYO</strong> is synonymous with
          <strong>INTERNATIONAL CAR</strong> buying.
        </p>
      </div>
      <div class="invest-intro-end">
        <div class="invest-intro-buttons">
          <button
            class="invest-button"
            @click="onModalOpen('investor')"
          >
            Apply to invest
          </button>
          <button
            class="invest-button-outline"
            @click="onModalOpen('general')"
          >
            More info
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onModalOpen: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
